import React, { useRef } from 'react';
import classNames from 'classnames';

import { NewsTickerItemData } from '@/models/feed';
import Icon from '@/components/Icon';

import { NewsTickerItemStatus } from '..';
import * as styles from './styles.module.scss';

const TRANSITION_DURATION_MS = 600;

const NewsTickerItem = ({ status, message }: { status: NewsTickerItemStatus; message: NewsTickerItemData }) => {
    const currentMessage = useRef<NewsTickerItemData>(message);
    if (status === 'middle') {
        // Only update text when item is off screen
        currentMessage.current = message;
    }

    const transitionDuration = status === 'bottom' ? 0 : TRANSITION_DURATION_MS;
    const statusToY = {
        bottom: '100%',
        middle: '0',
        top: '-100%',
    };

    return (
        <div
            className={styles.NewsTickerItem}
            style={{ transform: `translateY(${statusToY[status]})`, transitionDuration: transitionDuration + 'ms' }}
        >
            {currentMessage.current && (
                <div className={classNames(styles.message, styles[currentMessage.current.type])}>
                    <div className={styles.icon}>
                        <Icon type={currentMessage.current.icon} size={12} />
                    </div>
                    <p>{formatMessage(currentMessage.current.message, currentMessage.current.data)}</p>
                </div>
            )}
        </div>
    );
};

function formatMessage(message: string, data: { [key: string]: string | number }): JSX.Element {
    if (!data) return <>{message}</>;
    // Example message: [person] did the thing. So did [others].
    const PLACEHOLDER_REGEX = /(\[.*?\])/g;
    const SQUARE_BRACKETS_REGEX = /\[|\]/g;
    // Split into parts
    const parts = message.split(PLACEHOLDER_REGEX).map((part, index) => {
        // If part is a placeholder...
        if (part.match(PLACEHOLDER_REGEX)) {
            // Remove the square brackets
            const key = part.replace(SQUARE_BRACKETS_REGEX, '');
            // If found inside the data, replace the key with the data and put inside a span.
            return data.hasOwnProperty(key) ? <span key={`${key}-${index}`}>{data[key]}</span> : key;
        }
        return part;
    });

    return <>{parts}</>;
}

export default NewsTickerItem;
